import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {ItemModule} from "../../../../../../core/component/item/item.module";
import {LovValueSelectFilterModule} from "../../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";
import {MedicalRecordSportYearInputModule} from "../medical-record-sport-year-input/medical-record-sport-year-input.module";
import {RichTextEditorModule} from "../../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {SelectFilterModule} from "../../../../../../../components/common/select-filter/select-filter.module";
import {MedicalRecordSportSaveFormComponent} from "./medical-record-sport-save-form.component";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        LovValueSelectFilterModule,
        FormFieldModule,
        MedicalRecordSportYearInputModule,
        RichTextEditorModule,
        SelectFilterModule,
        CardV2Component,
    ],
    declarations: [
        MedicalRecordSportSaveFormComponent,
    ],
    exports: [
        MedicalRecordSportSaveFormComponent,
    ],
})
export class MedicalRecordSportSaveFormModule {
}
